import { LogMessage, PROD_BUILD } from "../helper-func";
import { CreateSvgObject, CreateSvgObjectFromJson } from "./svg-object";
// The original size of image.
let imageSize = null;
// The type of annotation object selected from toolbar.
let selectedObjectShape = null;
// Track the current drawing object.
let currentDrawingObject = null;
let currentTextObject = null;
// Track selected object.
let selectedObject = null;
let isDrawingObject = false;
let isMovingObject = false;
let startPoint = null;
let clickIsNotForText = false;
//Use to undo a moving operation.
let initialPositionDelta = null;
// The root to append svg object.
let svgGroup = null;
// map from svg object id to svg object.
let svgIdToObjs = new Map();
// Callbacks to receive updates
let updateCallback = null;
function runUpdateCallback() {
    if (updateCallback)
        updateCallback();
}
function EnableButton(id, enabled) {
    document.querySelector(`#${id}`).disabled = !enabled;
}
function AddClickEventToButton(button_id, callback) {
    const options = {
        capture: true,
    };
    document.getElementById(button_id).addEventListener("click", callback, options);
}
const MAX_UNDO_REDO = 8;
const undoStack = [];
const redoStack = [];
function inspectUndoStack() {
    if (PROD_BUILD)
        return;
    LogMessage(`undo stack length: ${undoStack.length}`);
    for (const op of undoStack) {
        LogMessage(op.object);
    }
}
function pushOpToStack(id, op, stack, msg = '') {
    stack.push(op);
    if (stack.length >= MAX_UNDO_REDO) {
        stack.shift();
    }
    EnableButton(id, true);
    if (msg.length > 0) {
        LogMessage(msg);
    }
    runUpdateCallback();
}
// Return if the shape indicated by button is selected.
export function toggleSelectedShape(button_id) {
    const toggleButtonClass = 'atb_selected';
    const button = document.querySelector(`#${button_id}`);
    const isSelected = button.classList.contains(toggleButtonClass);
    const buttons = document.querySelectorAll('.annotation_toolbar_button');
    buttons.forEach((b) => {
        b.classList.remove(toggleButtonClass);
    });
    selectedObjectShape = null;
    if (!isSelected) {
        button.classList.add(toggleButtonClass);
        const id = button.id;
        selectedObjectShape = id.split('_')[1];
        LogMessage(`Add class for button: ${button.id} and shape: ${selectedObjectShape}`);
    }
    return !isSelected;
}
// Callback to handle the event when the svg object is selected.
const svgObjectClickedCallback = (obj, event) => {
    // deselect current selected object.
    if (selectedObject) {
        selectedObject.selectObject(false);
    }
    selectedObject = obj;
    obj.selectObject(true);
    EnableButton('annotation_del', true);
    // This is important, when the object is selected, we don't want the click event
    // propagated to parent, a.k.a #svgContainer.
    event.stopPropagation();
};
// The logic to handle object drawing and dragging.
// 1. When object is selected, if mouse move/mouse down is in selected object,
//    then move selected object. If mouse events is not in selected object,
//    deselect the selected object and go to next action.
// 2. When object type (e.g. rect) is selected, but no object is selected,
//    mouse events will create and draw object.
// 3. When no object type is selected, and no object is selected, do nothing;
//
// 4. Text is different since it accepts text input. When the mouse is clicked,
//   A input box is popuped up, user can input text. When the mouse click again,
//   the popup disapear.
function handleObjectDrawingAndDraging(imageContainer, svgContainer) {
    // Handle mouse event to add shape.
    const options = {
        capture: true,
    };
    const mouseEventPosition = (event) => {
        let scale = 1.0;
        // Make sure the position aligned with original image size.
        if (imageSize.width > window.innerWidth) {
            scale = imageSize.width / window.innerWidth;
        }
        return {
            x: Math.floor(event.offsetX * scale),
            y: Math.floor(event.offsetY * scale),
        };
    };
    // For text
    svgContainer.addEventListener('click', (event) => {
        const pt = mouseEventPosition(event);
        LogMessage(`click event: ${pt.x}, ${pt.y}`);
        if (currentTextObject) {
            currentTextObject.endTextInput(svgGroup);
            currentTextObject = null;
            return;
        }
        if (clickIsNotForText || selectedObjectShape != 'text') {
            clickIsNotForText = false;
            return;
        }
        currentTextObject = CreateSvgObject('text', pt, svgObjectClickedCallback);
        svgIdToObjs.set(currentTextObject.id, currentTextObject);
        currentTextObject.textDoneCb = (obj) => {
            const op = {
                object: obj,
                undo_op: (obj) => {
                    obj.detachFromRoot();
                },
                redo_op: (obj) => {
                    obj.attachToRoot(svgGroup);
                },
            };
            pushOpToStack('annotation_undo', op, undoStack);
        };
        currentTextObject.startTextInput(imageContainer, svgGroup);
    });
    svgContainer.addEventListener('mousedown', (event) => {
        event.preventDefault();
        const pt = mouseEventPosition(event);
        LogMessage(`Mouse down at: <${pt.x} ${pt.y}>`);
        if (selectedObject) {
            if (selectedObject.isPointInSurroundingRect(pt)) {
                // Ready to move a object.
                isMovingObject = true;
                clickIsNotForText = true;
                startPoint = pt;
                initialPositionDelta = selectedObject.positionDelta;
                return;
            }
            else {
                // Click somewhere else, unselect selectedObject.
                selectedObject.selectObject(false);
                selectedObject = null;
            }
        }
        // text is not considered as drawing object since it doesn't require mouse
        // moving.
        if (selectedObjectShape && selectedObjectShape != "text") {
            isDrawingObject = true;
            clickIsNotForText = true;
            startPoint = pt;
            return;
        }
        LogMessage('No object shape is selected.');
    }, options);
    svgContainer.addEventListener('mousemove', (event) => {
        event.preventDefault();
        if (event.buttons !== 1) {
            // Only handle mousemove event when the left button is pressed.
            return;
        }
        const pt = mouseEventPosition(event);
        if (isMovingObject) {
            LogMessage(`Move object move to: ${pt.x} ${pt.y}`);
            const delta = {
                x: pt.x - startPoint.x,
                y: pt.y - startPoint.y
            };
            selectedObject.moveObject(delta);
            startPoint = pt;
            return;
        }
        else if (!isDrawingObject) {
            return;
        }
        if (currentDrawingObject == null) {
            currentDrawingObject = CreateSvgObject(selectedObjectShape, startPoint, svgObjectClickedCallback);
            svgIdToObjs.set(currentDrawingObject.id, currentDrawingObject);
        }
        // LogMessage(`Draw object move to: ${event.x} ${y}`);
        if (!currentDrawingObject.isAttached) {
            currentDrawingObject.setEndPoint(pt);
            currentDrawingObject.attachToRoot(svgGroup);
        }
        else {
            currentDrawingObject.updateEndPoint(pt);
        }
    }, options);
    const finishMouseEvent = (event) => {
        if (isMovingObject) {
            const initDelta = { ...initialPositionDelta };
            const finalDelta = { ...selectedObject.positionDelta };
            const op = {
                object: selectedObject,
                undo_op: (obj) => {
                    obj.setPositionDelta(initDelta);
                },
                redo_op: (obj) => {
                    obj.setPositionDelta(finalDelta);
                },
            };
            // LogMessage(`push moving undo: ${undoStack.length}`);
            pushOpToStack('annotation_undo', op, undoStack);
        }
        else if (isDrawingObject && currentDrawingObject) {
            const op = {
                object: currentDrawingObject,
                undo_op: (obj) => {
                    obj.detachFromRoot();
                },
                redo_op: (obj) => {
                    obj.attachToRoot(svgGroup);
                },
            };
            // LogMessage(`push drawing undo: ${undoStack.length}`);
            pushOpToStack('annotation_undo', op, undoStack);
        }
        currentDrawingObject = null;
        isDrawingObject = false;
        isMovingObject = false;
    };
    svgContainer.addEventListener('mouseup', (event) => {
        event.preventDefault();
        const pt = mouseEventPosition(event);
        LogMessage(`Mouse up at: <${pt.x} ${pt.y}>`);
        finishMouseEvent(event);
    }, options);
    svgContainer.addEventListener('mouseleave', (event) => {
        event.preventDefault();
        if (event.target != svgContainer) {
            // LogMessage('wrong mouseleave target');
            return;
        }
        const pt = mouseEventPosition(event);
        LogMessage(`Mouse Leave at: ${pt.x} ${pt.y}`);
        finishMouseEvent(event);
    }, options);
}
function delSelectedObject() {
    if (!selectedObject)
        return;
    selectedObject.selectObject(false);
    selectedObject.detachFromRoot();
    const op = {
        object: selectedObject,
        undo_op: (obj) => {
            obj.attachToRoot(svgGroup);
        },
        redo_op: (obj) => {
            obj.detachFromRoot();
        }
    };
    pushOpToStack('annotation_undo', op, undoStack);
    EnableButton('annotation_del', false);
    selectedObject = null;
}
function handleKeydownEvent() {
    document.addEventListener("keydown", (event) => {
        LogMessage(`key down: ${event.key}`);
        switch (event.key) {
            case 'Delete':
            case 'Backspace':
                return delSelectedObject();
            case 'a':
            case 'A':
                return toggleSelectedShape('annotation_arrow');
            case 'd':
            case 'D':
                return toggleSelectedShape('annotation_darrow');
            case 'c':
            case 'C':
                return toggleSelectedShape('annotation_ellipse');
            case 'r':
            case 'R':
                return toggleSelectedShape('annotation_rect');
            case 'p':
            case 'P':
                return toggleSelectedShape('annotation_draw');
            case 't':
            case 'T':
                return toggleSelectedShape('annotation_text');
            default:
                LogMessage(`unknown keydown ${event.key}`);
                return;
        }
    });
}
export function ShowSvgContainer(imageContainer, svgContainer, imgSize, readonly) {
    LogMessage(`Show svg container with size: ${imgSize.width} ${imgSize.height}`);
    imageSize = imgSize;
    svgContainer.classList.remove('hidden');
    svgGroup = svgContainer.querySelector('g');
    const setViewport = () => {
        const svgW = Math.max(imgSize.width, window.innerWidth);
        const svgH = Math.max(imgSize.height, window.innerHeight);
        svgContainer.setAttribute("viewBox", `0 0 ${svgW} ${svgH}`);
        LogMessage(`svg container viewport: ${svgW} ${svgH} imageW: ${imgSize.width} windowW: ${window.innerWidth}`);
        return [svgW, svgH];
    };
    setViewport();
    window.addEventListener("resize", () => {
        // LogMessage(`window: ${window.innerWidth} image: ${imgSize.width} curImage: ${croppedImage.clientWidth} offsetLeft: ${croppedImage.offsetLeft} svgViewport: ${svgW}`);
        setViewport();
    });
    if (!readonly) {
        RegisterEditorCommands(imageContainer, svgContainer);
    }
}
export function RegisterEditorCommands(imageContainer, svgContainer) {
    // Register events for object types. It does:
    //  - select / deselect object type;
    AddClickEventToButton('annotation_arrow', () => {
        toggleSelectedShape('annotation_arrow');
    });
    AddClickEventToButton('annotation_darrow', () => {
        toggleSelectedShape('annotation_darrow');
    });
    AddClickEventToButton('annotation_ellipse', () => {
        toggleSelectedShape('annotation_ellipse');
    });
    AddClickEventToButton('annotation_rect', () => {
        toggleSelectedShape('annotation_rect');
    });
    AddClickEventToButton('annotation_draw', () => {
        toggleSelectedShape('annotation_draw');
    });
    AddClickEventToButton('annotation_text', () => {
        toggleSelectedShape('annotation_text');
    });
    // Register events for del undo/redo.
    AddClickEventToButton('annotation_del', () => {
        delSelectedObject();
    });
    AddClickEventToButton('annotation_undo', () => {
        inspectUndoStack();
        const op = undoStack.pop();
        if (undoStack.length == 0) {
            EnableButton('annotation_undo', false);
        }
        if (op) {
            op.undo_op(op.object);
            pushOpToStack('annotation_redo', op, redoStack);
        }
    });
    AddClickEventToButton('annotation_redo', () => {
        inspectUndoStack();
        const op = redoStack.pop();
        if (redoStack.length == 0) {
            EnableButton('annotation_redo', false);
        }
        if (op) {
            op.redo_op(op.object);
            pushOpToStack('annotation_undo', op, undoStack);
        }
    });
    EnableButton('annotation_undo', false);
    EnableButton('annotation_redo', false);
    EnableButton('annotation_del', false);
    handleObjectDrawingAndDraging(imageContainer, svgContainer);
    handleKeydownEvent();
}
export function SerializeSvgObjects(svgContainer) {
    const svgs = svgContainer.querySelectorAll('g > svg');
    LogMessage(`Number of svg: ${svgs.length}`);
    // Definition of svg object
    // {
    //    transform: from g[name="wrap"],
    //    elements:  children of g[name="obj"]
    // }
    const svgObjs = [];
    svgs.forEach((svg) => {
        const p = svg.querySelector('g[name="obj"]');
        const boundingBox = p.getBoundingClientRect();
        if (boundingBox.width == 0 || boundingBox.height == 0) {
            LogMessage('Skipping svg object with 0 bounding box');
            return;
        }
        const id = svg.getAttribute('id');
        if (!svgIdToObjs.has(id)) {
            return;
        }
        const svgObj = svgIdToObjs.get(id);
        svgObjs.push(svgObj.toJson());
    });
    return JSON.stringify(svgObjs);
}
// This function should be called after ShowSvgContainer since it prepare the context.
export function ParseAndShowSvgObjects(serializedObjects, readonly) {
    let cb = (obj, event) => { };
    if (!readonly) {
        cb = svgObjectClickedCallback;
    }
    const svgObjs = JSON.parse(serializedObjects);
    for (const jsonObj of svgObjs) {
        const svgObj = CreateSvgObjectFromJson(svgGroup, jsonObj, cb);
        if (svgObj == null) {
            LogMessage('Skipped svg object:');
            LogMessage(jsonObj);
            continue;
        }
        svgIdToObjs.set(svgObj.id, svgObj);
        LogMessage(`ParseAndShowSvgObjects, add ${svgObj.id}`);
    }
    LogMessage(`ParseAndShowSvgObjects: ${svgIdToObjs.size}`);
}
// Remove all objects
export function ClearSvgObjects() {
    LogMessage(`Clear all objects: ${svgIdToObjs.size}`);
    for (const [_, obj] of svgIdToObjs) {
        LogMessage(`clear svg object: ${obj.id}`);
        obj.detachFromRoot();
    }
    svgIdToObjs.clear();
}
export function SetAnnotationUpdatedCallback(upcb) {
    updateCallback = upcb;
}
